<mbs-modal [isCustomModal]="true"
           [title]="title">
  <ng-container modal-body
                [formGroup]="form">
    <mbs-form-group>
      <ng-container *ngTemplateOutlet="frequency"></ng-container>
      <ng-container *ngTemplateOutlet="presets"></ng-container>
      <ng-container *ngTemplateOutlet="days"></ng-container>
      <ng-container *ngTemplateOutlet="occurrence"></ng-container>
      <ng-container *ngTemplateOutlet="calendarDay"></ng-container>
      <ng-container *ngTemplateOutlet="daysSelect"></ng-container>
      <ng-container *ngTemplateOutlet="time"></ng-container>
      <ng-container *ngTemplateOutlet="repeat"></ng-container>

      <ng-template #frequency>
        <div class="row">
          <div class="col-4">{{'wizards:schedule.scheduleModal.backupFrequency.title' | i18next}}:</div>
          <div class="col-8 ml-n5">
            <div class="row">
              <mbs-radio formControlName="recurringPeriod"
                         name="recurringPeriod"
                         value="Daily"
                         [label]="'wizards:schedule.scheduleModal.backupFrequency.daily' | i18next"
                         [id]="elementSelectors.id.dailyRadio"
                         (change)="setFrequency('Daily')"></mbs-radio>
              <mbs-radio class="mt-0 ml-3"
                         formControlName="recurringPeriod"
                         name="recurringPeriod"
                         value="Monthly"
                         [label]="'wizards:schedule.scheduleModal.backupFrequency.monthly' | i18next"
                         [id]="elementSelectors.id.monthlyRadio"
                         (change)="setFrequency('Monthly')"></mbs-radio>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #presets>
        <div *ngIf="isDaily"
             class="row mt-4"
             [id]="elementSelectors.id.presetsBlock">
          <div class="col-4">{{'wizards:schedule.scheduleModal.recommendedPresets.title' | i18next}}:</div>
          <div class="col-8 ml-n5 mt-n1">
            <div class="row">
              <mbs-button [type]="!!preset.weekdays ? 'primary' : 'outline-primary'"
                          [rounded]="true"
                          [id]="elementSelectors.id.presetWeekdaysButton"
                          (click)="setPreset('weekdays')">
                {{'wizards:schedule.scheduleModal.recommendedPresets.weekdays' | i18next}}
              </mbs-button>
              <mbs-button class="ml-2"
                          [type]="!!preset.everyday ? 'primary' : 'outline-primary'"
                          [rounded]="true"
                          [id]="elementSelectors.id.presetEverydayButton"
                          (click)="setPreset('everyday')">
                {{'wizards:schedule.scheduleModal.recommendedPresets.everyday' | i18next}}
              </mbs-button>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #days>
        <div *ngIf="isDaily"
             class="row mt-4"
             [id]="elementSelectors.id.daysBlock">
          <div class="col-4">{{'wizards:schedule.scheduleModal.days.title' | i18next}}:</div>
          <div class="col-8 ml-n5 mt-n1">
            <mbs-button-group class="row"
                              [toggle]="false">
              <mbs-button *ngFor="let day of week; let i = index"
                          [type]="!!day ? 'primary' : 'outline-primary'"
                          [id]="elementSelectors.id.dayId(i)"
                          (click)="setDay(i)">
                {{ daysShort[i] }}
              </mbs-button>
            </mbs-button-group>
          </div>
        </div>
      </ng-template>

      <ng-template #occurrence>
        <div *ngIf="isMonthly"
             class="row mt-4"
             [id]="elementSelectors.id.occurrenceBlock">
          <div class="col-4">
            {{'wizards:schedule.scheduleModal.occurrence.title' | i18next}}:
            <span class="fa fa-info-circle ml-2 cursor-help text-info"
                  container="body"
                  tooltipClass="tooltip-xl text-left"
                  [placement]="'right'"
                  [ngbTooltip]="occurrenceTooltip"></span>
            <ng-template #occurrenceTooltip>
              <div>
                <strong>{{'wizards:schedule.scheduleModal.occurrence.tooltip.DOM' | i18next}}: </strong>
                <span>{{'wizards:schedule.scheduleModal.occurrence.tooltip.DOMInfo' | i18next}}</span>
              </div>
              <div>
                <strong>{{'wizards:schedule.scheduleModal.occurrence.tooltip.FSTF' | i18next}}: </strong>
                <span>{{'wizards:schedule.scheduleModal.occurrence.tooltip.FSTFInfo' | i18next}}</span>
              </div>
              <div>
                <strong>{{'wizards:schedule.scheduleModal.occurrence.tooltip.PL' | i18next}}: </strong>
                <span>{{'wizards:schedule.scheduleModal.occurrence.tooltip.PLInfo' | i18next}}</span>
              </div>
            </ng-template>
          </div>
          <div class="col-3 ml-n5 mt-n1 pl-0">
            <mbs-select formControlName="occurrence"
                        [appendTo]="'mbs-modal'"
                        [bindValue]="'value'"
                        [bindLabel]="'label'"
                        [clearable]="false"
                        [id]="elementSelectors.id.occurrenceSelect"
                        [items]="weekNumberEnumArray"
                        [searchable]="false"></mbs-select>
          </div>
        </div>
      </ng-template>

      <ng-template #calendarDay>
        <div *ngIf="isMonthly && isDayOfMonth"
             class="row mt-4"
             [id]="elementSelectors.id.calendarDayBlock">
          <div class="col-4">{{'wizards:schedule.scheduleModal.calendarDay.title' | i18next}}:</div>
          <div class="col-3 ml-n5 mt-n1 pr-4">
            <mbs-number formControlName="dayOfMonthCount"
                        class="row"
                        min="1"
                        max="31"></mbs-number>
          </div>
        </div>
      </ng-template>

      <ng-template #daysSelect>
        <div *ngIf="isMonthly && isCountableDayOfMonth"
             class="row mt-4"
             [id]="elementSelectors.id.daysSelectBlock">
          <div class="col-4">{{'wizards:schedule.scheduleModal.daysSelect.title' | i18next}}:</div>
          <div class="col-3 ml-n5 mt-n1 pl-0">
            <mbs-select formControlName="dayOfWeek"
                        [appendTo]="'mbs-modal'"
                        [bindValue]="'value'"
                        [bindLabel]="'label'"
                        [clearable]="false"
                        [items]="daysOfWeekEnumArray"
                        [searchable]="false"></mbs-select>
          </div>
        </div>
      </ng-template>

      <ng-template #time>
        <div class="row mt-4">
          <div class="col-4">
            {{'wizards:schedule.scheduleModal.time.title' | i18next}}:
            <span *ngIf="isFullEqualIncremental"
                  [id]="elementSelectors.id.timeTooltip"
                  class="fa fa-info-circle ml-2 cursor-help text-info"
                  container="body"
                  tooltipClass="tooltip-lg"
                  [placement]="'right'"
                  [ngbTooltip]="timeTooltip"></span>
            <ng-template #timeTooltip>
              {{'wizards:schedule.scheduleModal.time.tooltip' | i18next}}
            </ng-template>
          </div>
          <div class="col-8 ml-n5">
            <div *ngIf="!isFull && isDaily"
                 class="row"
                 [id]="elementSelectors.id.timeRadioBlock">
              <mbs-radio formControlName="dailyFreqPeriodOption"
                         value="OccursAt"
                         class="mb-2"
                         (change)="dailyPeriodChangeHandler($event)"
                         [label]="'wizards:schedule.scheduleModal.time.specificTime' | i18next"
                         [id]="elementSelectors.id.timeSpecificRadio"></mbs-radio>
              <mbs-radio formControlName="dailyFreqPeriodOption"
                         value="OccursEvery"
                         class="mt-0 ml-3 mb-2"
                         (change)="dailyPeriodChangeHandler($event)"
                         [label]="'wizards:schedule.scheduleModal.time.severalTime' | i18next"
                         [id]="elementSelectors.id.timeSeveralRadio"></mbs-radio>
            </div>
            <div *ngIf="isSpecificTime"
                 class="row"
                 [id]="elementSelectors.id.timeSpecificBlock">
              <div class="col-4 pl-0">
                <mbs-timepicker formControlName="occursAtTime"
                                [meridian]="true"
                                [needChangeInvalid]="true"
                                [id]="elementSelectors.id.timeSpecificTimepicker"></mbs-timepicker>
              </div>
            </div>
            <div *ngIf="!isSpecificTime"
                 class="row"
                 [id]="elementSelectors.id.timeSeveralBlock1">
              <div class="col-1 pl-0 mr-1">
                <mbs-input-label class="mbs-form_label mb-0"
                                 [label]="'wizards:schedule.scheduleModal.time.every' | i18next"></mbs-input-label>
              </div>
              <div class="col-3 pl-0 mt-n1">
                <mbs-number formControlName="occursEveryCount"
                            [max]="form.get('occursEveryPeriod').value === 'hours' ? 23 : 1439"
                            [min]="1"
                            [id]="elementSelectors.id.timeSeveralEveryNumber"></mbs-number>
              </div>
              <div class="col-3 pl-0 mt-n1">
                <mbs-select formControlName="occursEveryPeriod"
                            [items]="hoursOrMinutesItems"
                            [bindLabel]="'label'"
                            [bindValue]="'value'"
                            [searchable]="false"
                            [clearable]="false"
                            [id]="elementSelectors.id.timeSeveralPeriod"></mbs-select>
              </div>
            </div>
            <div *ngIf="!isSpecificTime"
                 class="row mt-2"
                 [id]="elementSelectors.id.timeSeveralBlock2">
              <div class="col-1 pl-0 mr-1">
                <mbs-input-label class="mbs-form_label mb-0"
                                 [label]="'wizards:schedule.scheduleModal.time.from' | i18next"></mbs-input-label>
              </div>
              <div class="col-4 pl-0 mt-n1">
                <mbs-timepicker formControlName="occursEveryFromTime"
                                [meridian]="true"
                                [needChangeInvalid]="true"
                                [id]="elementSelectors.id.timeSeveralTime1"></mbs-timepicker>
              </div>
              <div class="col-auto pl-0">
                <mbs-input-label class="mbs-form_label mb-0"
                                 [label]="'wizards:schedule.scheduleModal.time.to' | i18next"></mbs-input-label>
              </div>
              <div class="col-4 pl-0 mt-n1">
                <mbs-timepicker formControlName="occursEveryToTime"
                                [meridian]="true"
                                [needChangeInvalid]="true"
                                [id]="elementSelectors.id.timeSeveralTime2"></mbs-timepicker>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #repeat>
        <div class="row mt-4">
          <div class="col-4">{{'wizards:schedule.scheduleModal.repeat.title' | i18next}}:</div>
          <div class="col-3 ml-n5 mt-n1 pr-4">
            <mbs-number class="row"
                        formControlName="repeatEveryCount"
                        [min]="1"
                        [max]="31"
                        [id]="elementSelectors.id.repeatEveryNumber"></mbs-number>
          </div>
          <div *ngIf="!isMonthly"
               class="col-auto"
               [id]="elementSelectors.id.repeatEveryWeeks">
            {{'wizards:schedule.scheduleModal.repeat.weeks' | i18next}}
          </div>
          <div *ngIf="isMonthly"
               class="col-auto"
               [id]="elementSelectors.id.repeatEveryMonths">
            {{'wizards:schedule.scheduleModal.repeat.months' | i18next}}
          </div>
        </div>
      </ng-template>
    </mbs-form-group>
  </ng-container>

  <ng-container modalFooter>
    <button type="button"
            class="btn btn-primary"
            [attr.data-test-element]="elementSelectors.id.saveButton"
            [disabled]="form.invalid"
            (click)="saveClickHandler()">{{ 'shared:buttons.save' | i18next: { format: 'title' } }}</button>
    <button type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            [attr.data-test-element]="elementSelectors.id.cancelButton"
            (click)="cancelClickHandler()">{{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}</button>
  </ng-container>
</mbs-modal>
